import React from 'react';
import loadable from '@loadable/component';
import LoadingPage from '../LoadingPage';
import { styled } from 'linaria/react';
import posed from 'react-pose';

// Keep the FilterAnimation for SearchResults.js
export const FilterAnimation = styled(
  posed('div')({
    closed: {
      height: 0,
      opacity: 0,
      overflow: 'hidden',
    },
    open: {
      height: 'auto',
      opacity: 1,
      duration: 600,
      applyAtEnd: { overflow: 'visible' },
    },
  })
)`
  flex: 1 1 25%;
`;

// Change this to load the new Category component
export const LoadableCategoryListing = loadable(
  () => import('./CategoryListing'),
  {
    fallback: <LoadingPage />,
  }
);

export const LoadableStandardCategoryPage = loadable(
  () => import('./StandardCategoryPage'),
  {
    fallback: <LoadingPage />,
  }
);

const CategoryPage = (props) => {
  return <LoadableStandardCategoryPage {...props} />;
};

export default CategoryPage;
